import PropTypes from 'prop-types'
import { DateTime } from 'luxon'

export const DayOfWeek = ({ isoDate }) => DateTime.fromISO(isoDate).weekdayLong

DayOfWeek.propTypes = {
  isoDate: PropTypes.string.isRequired
}
